import React, { Component, PropTypes } from 'react';
import { RadioGroup, RadioButton } from 'react-toolbox/lib/radio';
import { fetch } from 'lib/network/webapi';
import { Button } from 'react-toolbox/lib/button';
import { connect } from 'react-redux';
import { VirtualizedSelect } from 'containers';
import Dialog from 'react-toolbox/lib/dialog';
import moment from 'moment';
import Modal from 'react-modal';
import _debug from 'debug';
import _ from 'lodash';
import * as util from 'lib/utility';
import * as filterActions from '../../state/modules/filter';
import styles from './Footer.css';

const debug = _debug('app:Footer');
export class Footer extends Component {
  static propTypes = {
    activeIndex: PropTypes.number,
    agentList: PropTypes.arrayOf(PropTypes.shape({})),
    agentPrimaryList: PropTypes.arrayOf(PropTypes.shape({})),
    tabOneList: PropTypes.arrayOf(PropTypes.shape({})),
    tabTwoList: PropTypes.arrayOf(PropTypes.shape({})),
    selectedRecords: React.PropTypes.arrayOf(React.PropTypes.shape({})),
    confirmAssignment: React.PropTypes.func,
    applyAssignment: React.PropTypes.func,
    updateOwnerid: React.PropTypes.func,
    ownerId: React.PropTypes.string,
    ownerGuid: React.PropTypes.string,
    originalOwnerGuid: React.PropTypes.string,
    updateProgressBarValue: React.PropTypes.func,
    updateProgressBarMaxCount: React.PropTypes.func,
    resetProgressBar: React.PropTypes.func,
    updateSelectedRecords: React.PropTypes.func,
    filterValues: PropTypes.shape({}),
    reverseFilter: PropTypes.func,
    updateFilter: PropTypes.func,
    currentLanguage: PropTypes.string,
    // resetActiveFilter: PropTypes.func,//eslint-disable-line
    callLoadingScreen: React.PropTypes.func,
    isProgressBarRendered: PropTypes.bool,
    dispositionOptionSet: PropTypes.arrayOf(PropTypes.shape({})),
    username: PropTypes.string,
    isMarketOpen: PropTypes.string,
    loginUserRecord: PropTypes.shape({}),
    primaryMarketId: PropTypes.string,
    secondMarketValues: PropTypes.arrayOf(PropTypes.shape({})),
    strings: PropTypes.shape({})
  }

  state = {
    label: 'DM/SC',
    valueSelected: [],
    activeIndex: this.props.activeIndex,
    active: false,
    errorMessage: '',
    okMsg: '',
    cancelMsg: '',
    reConfirm: false,
    checkAssign: 'Re-Assign'
  };

  componentWillReceiveProps(nextProps) {
    if (this.state.activeIndex !== nextProps.activeIndex) {
      this.setState({
        valueSelected: [],
        activeIndex: nextProps.activeIndex
      });
    }
  }

  getUserPosition = () => {
    let userPostion = '';
    const loginUserRecord = this.props.loginUserRecord;
    if (loginUserRecord.cica_positioncode === '14') {
      userPostion = 'MD';
    } else if (loginUserRecord.cica_positioncode === '10' || loginUserRecord.cica_positioncode === '06') {
      userPostion = 'SC/DM';
    } else if (loginUserRecord.cica_positioncode === '13') {
      userPostion = 'AM';
    } else if ((loginUserRecord.cica_positioncode === '16') && loginUserRecord.cica_salesforce === '02') { // Salesforce - 02
      userPostion = 'AD';
    } else if (loginUserRecord.cica_positioncode === '60' && loginUserRecord.cica_salesforce === '02') { // Salesforce - 02
      userPostion = 'AL';
    } else if (loginUserRecord.cica_positioncode === '76' && loginUserRecord.cica_salesforce === '02') {
      userPostion = 'DL';
    } else if (loginUserRecord.cica_positioncode === '33' && loginUserRecord.cica_salesforce === '02') {
      userPostion = 'AC';
    } else if (loginUserRecord.cica_positioncode === '70' && loginUserRecord.cica_salesforce === '02') {
      userPostion = 'PR';
    }
    return userPostion;
  };

  getAgentList = () => {
    const userPostion = this.getUserPosition();
    const ownerName = this.props.username.split('.').join(' ');
    const loginUserRecord = this.props.loginUserRecord;
    const secondMarketValues = this.props.secondMarketValues;
    const userRecord = {
      fullname: ownerName,
      systemuserid: loginUserRecord.id,
      cica_positioncode: loginUserRecord.cica_positioncode,
      ownerid: loginUserRecord.id
    };
    let agentList = [];
    let filteredResult = '';
    if (userPostion === 'MD' || (userPostion === 'AD')) {
      if (this.props.isMarketOpen === 'OPEN') {
        agentList = _.filter(this.props.agentList, record =>
          record.systemuserid !== this.props.primaryMarketId);
      } else {
        agentList = this.props.agentList;
      }
    } else if (userPostion === 'SC/DM' || userPostion === 'AL' || userPostion === 'DL') {
      filteredResult = _.filter(this.props.agentList, record => (record.cica_positioncode === '04' || record.cica_positioncode === '33' || record.cica_positioncode === '31' || record.cica_positioncode === '75'));
      agentList = [...filteredResult, userRecord];
    } else if (userPostion === 'AC') {
      filteredResult = _.filter(this.props.agentList, record => (record.cica_positioncode === '04' || record.cica_positioncode === '31' || record.cica_positioncode === '75'));
      agentList = [...filteredResult, userRecord];
    } else if (userPostion === 'AM') {
      filteredResult = _.filter(this.props.agentList, record => record.cica_positioncode === '04');
      agentList = this.props.agentList;
    } else if (userPostion === 'PR') {
      filteredResult = _.filter(this.props.agentList, record => (record.cica_positioncode === '36'));
      agentList = [...filteredResult, userRecord];
    }
    if (secondMarketValues && secondMarketValues.length) {
      let filterMdList = agentList;
      secondMarketValues.forEach((id) => {
        if (id.openId === 'OPEN') {
          agentList = _.filter(filterMdList, list => list.systemuserid !== id.id1);
          filterMdList = agentList;
        }
      });
    }
    return _.orderBy(agentList, ['lastname'], ['asc']);
  }

  handleToggle = () => {
    this.setState({ active: !this.state.active });
  }

  okBtnTap = (evt) => {
    evt.preventDefault();
    this.setState({ reConfirm: false });
    this.confirm();
  }

  cancelTap = (evt) => {
    evt.preventDefault();
    this.setState({ reConfirm: false });
  }

  performAssignmentTask = (selectedAssignee, personToSearch, tabSpecificRecords) => (

    new Promise((resolve, reject) => {
      const batchSize = tabSpecificRecords.length <= __CONFIG__.pageSize ?
      tabSpecificRecords.length
      : Math.ceil(tabSpecificRecords.length / __CONFIG__.pageSize);

      if (!this.props.isProgressBarRendered) {
        /*
          This check is to ensure that progress bar is not reset when the it is already in view,
          and a new action is initiated.
        */
        this.props.resetProgressBar();
      }

      if (tabSpecificRecords.length <= __CONFIG__.pageSize) {
        this.props.updateProgressBarMaxCount(tabSpecificRecords.length);
      } else {
        this.props.updateProgressBarMaxCount(batchSize);
      }
      const selectedRecords = _.cloneDeep(tabSpecificRecords);
      const dataToUpdate = [{ suppressDuplicateErrors: 1, updates: [] }];
      for (const value of selectedRecords) {
        const dataDict = {
          action: 'U-URL',
          fields: {},
          modelName: 'lead',
          modelId: value.id
        };
        dataDict.fields.ownerId = selectedAssignee.systemuserid;
        dataDict.fields.cica_actualassignedbyuser = (this.props.originalOwnerGuid !== null || this.props.originalOwnerGuid !== '') ? this.props.originalOwnerGuid : null;
        dataDict.fields.cica_assignedbyuser = (this.props.ownerId !== null || this.props.ownerId !== '') ? this.props.ownerGuid : null;
        dataDict.fields.cica_leadassignmentsource = 2;
        dataDict.fields.cica_assigneddate = moment().format('YYYY-MM-DD');
        dataDict.fields.cica_leaddispositionstatus = (value.lastDispositionState !== 3 && value.lastDispositionState !== '3') ? 1 : 3; //eslint-disable-line
        dataDict.fields.isappointmentterminated = (value.lastDispositionState !== 3 && value.lastDispositionState !== '3') ? false : true; //eslint-disable-line
        dataDict.fields.cica_attemptedcontactnumber = 0;
        value.isappointmentterminated = (value.lastDispositionState !== 3 && value.lastDispositionState !== '3') ? false : true; //eslint-disable-line
        value.cica_leaddispositionstatus = (value.lastDispositionState !== 3 && value.lastDispositionState !== '3') ? 1 : 3; //eslint-disable-line
        /* As per CICA-8103 - As an agent I would like my notes to be preserved
        if a lead is reassigned or expired and assigned again to me,
        so that I can always have my notes
          For eg:
          1) Agent A makes notes MD 1 reassigned again to Agent A notes are preserved
          2) Agent A makes notes MD 1 reassigned to Agent B, notes are NOT preserved
          3) Agent A makes notes Lead Expires
          MD 1 assigned again to Agent A and notes are preserved Agent A
          4) Agent A makes notes Lead Expires MD 1 assigns to Agent B notes are NOT preserved
        */
        dataDict.fields.cica_selfassigned = false;
        /* Updating cica_lastdispositionstate, cica_lastassignedagent and cica_lastdispositiondate.
          1) Need to check if a reassignement is happening, only then we need to update
           the above mentioned 3 fields. (this.props.activeIndex === 1)
          2) Need to Check if reassignement is happening from an Agent or TM
            (We will use value.assignedTo)
          3) If it is and agent we will update fields. (cica_positioncode === '04')
          4) If it is a TM, we need to check if the TM was was working on it as an Agent.
           (cica_positioncode === '10')
          (Check cica_selfassigned)
              a) If Yes then update the field.
              b) If No dont do anything.
          5) For any other scenario, we dont update the fields.
        */
        // try {
        if (this.props.activeIndex) {
          let currentAssignedUser = this.props.agentList.filter(
            user => value.assignedTo.toLowerCase() === user.fullname.toLowerCase()
          );
          // this condition is added so that we can search
          // if its admin login
          // and user has selected value in both dropdowns
          // incase when user selects unassign -
          // the first dropdown Agent is not in the list since assign to agents are
          // all from second dropdown.
          // so we pick from agent Primary list
          if (_.isEmpty(currentAssignedUser)) {
            currentAssignedUser = this.props.agentPrimaryList.filter(
              user => value.assignedTo.toLowerCase() === user.fullname.toLowerCase()
            );
          }
          if (!_.isEmpty(currentAssignedUser)) {
            if (
                currentAssignedUser[0].cica_positioncode === '04' || currentAssignedUser[0].cica_positioncode === '31' ||
                currentAssignedUser[0].cica_positioncode === '36' || currentAssignedUser[0].cica_positioncode === '75' ||
                ((currentAssignedUser[0].cica_positioncode === '10' || currentAssignedUser[0].cica_positioncode === '60' || currentAssignedUser[0].cica_positioncode === '76' || currentAssignedUser[0].cica_positioncode === '33' ||
                currentAssignedUser[0].cica_positioncode === '70') && value.selfAssigned) ||
                ((currentAssignedUser[0].cica_positioncode === '14' || currentAssignedUser[0].cica_positioncode === '16') && value.selfAssigned) ||
                (currentAssignedUser[0].cica_positioncode === '13' && value.selfAssigned)
            ) {
              debug('value', value);
              const lastDisposition = value.disposition ? _.find(
                this.props.dispositionOptionSet,
                (x) => {
                  debug(x.label);
                  return x.label.toLowerCase() === value.disposition.toLowerCase();
                }
              ) : null;
              debug('lastDisposition', lastDisposition);
              dataDict.fields.cica_lastdispositionstate = !lastDisposition ? 'NA' : lastDisposition.value;
              dataDict.fields.cica_lastassignedagent = util.toTitleCase(value.assignedTo);
              dataDict.fields.cica_lastdispositiondate = moment().format('YYYY-MM-DD');
              // value.lastAssigned = util.toTitleCase(value.assignedTo);
            }
          }
          if (personToSearch === this.props.ownerGuid) {
            value.lastAssigned = util.toTitleCase(value.assignedTo);
            dataDict.fields.cica_assignedagentid = selectedAssignee.fullname;
            value.assignedTo = util.toTitleCase(selectedAssignee.fullname);
            if ((this.getUserPosition() === 'SC/DM' || this.getUserPosition() === 'MD' || this.getUserPosition() === 'AM' || this.getUserPosition() === 'AC/AL' || this.getUserPosition() === 'AD') && this.state.checkAssign === 'Re-Assign') {
              dataDict.fields.cica_selfassigned = true;
              value.selfAssigned = true;
            } else {
              value.selfAssigned = false;
              value.status = 'Unassigned';
            }
          } else {
            dataDict.fields.cica_assignedagentid = selectedAssignee.fullname;
            value.assignedTo = util.toTitleCase(selectedAssignee.fullname);
          }
        } else {
          if (personToSearch === this.props.ownerGuid) {
            if (this.radioButtonLabel() === 'Unassign') {
              dataDict.fields.cica_selfassigned = true; // check for condition of the self assigned
              value.selfAssigned = true;
            } else {
              value.selfAssigned = false;
            }
          }
          dataDict.fields.cica_assignedagentid = selectedAssignee.fullname;
          value.assignedTo = util.toTitleCase(selectedAssignee.fullname);
          value.status = 'Assigned';
          if (this.state.label === 'Unassign') {
            /* set the selfAssigned field */
          }
          const loginUserRecord = this.props.loginUserRecord;
          if ((this.getUserPosition() === 'SC/DM' || this.getUserPosition() === 'AM' || this.getUserPosition() === 'AC/AL') && this.props.ownerGuid === loginUserRecord.ownerid) {
            value.selfAssigned = true;
            dataDict.fields.cica_selfassigned = true;
            /* set the selfAssigned field */
          }
        }
        if (value.assignedTo !== value.lastAssigned) {
          dataDict.fields.cica_notes = '';
        } else {
          dataDict.fields.cica_notes = value.notes;
        }
        // } catch (e) {
        //   console.log(e);
        // }
        value.disposition = (value.lastDispositionState !== 3 && value.lastDispositionState !== '3') ? 'Unworked' : 'Appointment Set';
        dataToUpdate[0].updates.push(dataDict);
      }

      this.props.confirmAssignment(selectedRecords);
      this.props.applyAssignment();
      // this.props.resetActiveFilter();(whn no data) //eslint-disable-line
      const filterKeys = this.props.activeIndex ?
      _.keys(this.props.filterValues[1]) : _.keys(this.props.filterValues[0]);
      const filterValue = this.props.activeIndex ?
      this.props.filterValues[1] : this.props.filterValues[0];
      const tabList = this.props.activeIndex ? this.props.tabTwoList : this.props.tabOneList;
      for (const x of filterKeys) {
        if (filterValue[x].length) {
          const keyValue = _.uniq(tabList.map(a => a[x]));
          const updateFilterValue = _.intersection(filterValue[x], keyValue);
          if (updateFilterValue.length) {
            const updatedFilterArray = [];
            for (const y of updateFilterValue) {
              updatedFilterArray.push({
                clearableValue: false,
                label: y,
                value: y
              });
            }
            this.props.updateFilter(x, updatedFilterArray).then(() => {
              this.props.reverseFilter();
            });
          } else {
            this.props.updateFilter(x, []).then(() => {
              this.props.reverseFilter();
            });
          }
        }
      }

      this.props.reverseFilter();
      const assignmentCompleteCB = () =>
      this.props.updateProgressBarValue(tabSpecificRecords.length);
      const assignmentCompleteBatchCB = () =>
      this.props.updateProgressBarValue();
      if (tabSpecificRecords.length <= __CONFIG__.pageSize) {
        // for (const record of dataToUpdate[0]) {
        if (!__TRAINING__) {
          this.props.updateOwnerid(null, dataToUpdate, this.props.ownerId)
          .then(assignmentCompleteCB)
          .catch((error) => {
            debug(error);
            reject(error);
          });
        } else {
          assignmentCompleteCB();
        }
        // }
      } else {
        // const recordsToUpdate = tabSpecificRecords;
        const assignAll = Promise.method((index, start, end) => {
          if (!__TRAINING__) {
            let count = index;
            let startIndex = start;
            let endIndex = end;
            const batchList = dataToUpdate[0].updates.slice(startIndex, endIndex);
            const finalDataToPush = [{ suppressDuplicateErrors: 1, updates: [] }];
            finalDataToPush[0].updates = batchList;
            this.props.updateOwnerid(null, finalDataToPush, this.props.ownerId)
            .then(() => {
              assignmentCompleteBatchCB();
              startIndex = endIndex;
              endIndex += __CONFIG__.pageSize;
              count < batchSize - 1 ? assignAll(count += 1, startIndex, endIndex) : count; // eslint-disable-line
            }).catch((error) => {
              reject(error);
              debug(error);
            });
          } else {
            assignmentCompleteBatchCB();
          }
        });
        assignAll(0, 0, __CONFIG__.pageSize);
      }

      this.props.updateSelectedRecords('removeAll', tabSpecificRecords);
    })
  )

  confirm = () => {
    this.props.callLoadingScreen();
    const tabSpecificRecords = (this.props.activeIndex) ?
      this.props.selectedRecords.filter(obj => obj.status === 'Assigned') :
      this.props.selectedRecords.filter(obj => obj.status === 'Unassigned');
    let personToSearch;
    let selectedAssignee;
    if (this.state.valueSelected.length) {
      personToSearch = this.state.valueSelected[this.state.valueSelected.length - 1].value;
    } else if (this.state.checkAssign === 'Unassign') {
      personToSearch = this.props.ownerGuid;
    }
    if (this.props.agentList && this.props.agentList.length) {
      selectedAssignee = _.find(this.props.agentList, ['systemuserid', personToSearch]);
    }
    if (!selectedAssignee) {
      selectedAssignee = _.find(this.props.agentPrimaryList, ['systemuserid', personToSearch]);
    }
    const excludeFromLeadsCount = tabSpecificRecords.filter(
      obj => obj.leadType === 'Warm' || obj.leadType === 'Campaign' || obj.isSecondary
    ).length;
    debug('excludeFromLeadsCount =>>', excludeFromLeadsCount);
    debug('selectedAssignee =>>', selectedAssignee);
    const finalPlannedCount = tabSpecificRecords.length - excludeFromLeadsCount;

    // if (selectedAssignee === '' || !selectedAssignee) {
    //   this.props.callLoadingScreen();
    // } else {
    const modelName = ((selectedAssignee.cica_positioncode === '10' || selectedAssignee.cica_positioncode === '14' || selectedAssignee.cica_positioncode === '13' || selectedAssignee.cica_positioncode === '16' || selectedAssignee.cica_positioncode === '60' || selectedAssignee.cica_positioncode === '76' || selectedAssignee.cica_positioncode === '33' || selectedAssignee.cica_positioncode === '70') && selectedAssignee.systemuserid === this.props.ownerGuid) ?
     'lead-selfAssignedMD' : 'lead-Agent';
    fetch(modelName, selectedAssignee.internalemailaddress, 'url')
    .then((response) => {
      this.props.callLoadingScreen();
      const totalDataForAssignment = finalPlannedCount + response.data.data.result.length;
      // this condition is added to avoid adding limits to MD unassignment
      // 14 is MD, owner both same means MD assigning to himself
      // the tab selected is 1 that is assigned tab
      // and unassign means its coming back to MD
      // first check with tab it is?
      // active index === 1 means its Assign tab
      // Active Index === 0 means its Unassigned tab
      if (this.props.activeIndex === 1) {
        // in Assign there are two conditions
        // first is unassign
        // if MD is trying to unassign
        // allow any Limit
        // if SC is trying to unassign
        // allow any limit
        // But if its not unassign and is reassign then check if its to Agent/SC/MD
        if (this.state.checkAssign === 'Unassign') {
          this.performAssignmentTask(selectedAssignee, personToSearch, tabSpecificRecords);
        } else {
          this.checkAndAssignLeads(selectedAssignee, personToSearch,
            tabSpecificRecords, totalDataForAssignment);
        }
      } else {
        // in unassign tab only one Dropdown is there
        this.checkAndAssignLeads(selectedAssignee, personToSearch,
            tabSpecificRecords, totalDataForAssignment);
      }
      return null;
    })
    .catch((error) => {
      debug(error);
      this.props.callLoadingScreen();
    });
    // }
  }
  checkAndAssignLeads = (selectedAssignee, personToSearch,
    tabSpecificRecords, totalDataForAssignment) => {
    // Agent - cica_positioncode === 04
    // if its agent calculate the limit as 250
    // SC - cica_positioncode === 10
    // if its SC calculate the limit as below
    // - SC - 2500 Leads
    // - SC self assigned - 250 Leads
    // MD - cica_positioncode === 14
    // if its MD calculate the limit as below
    // - MD unlimited leads
    // - MD self assigned - 250 Leads
    // let allowedLimit = 0;
    debug('totalDataForAssignment', totalDataForAssignment);
    if (selectedAssignee.cica_positioncode === '04' || selectedAssignee.cica_positioncode === '36' || selectedAssignee.cica_positioncode === '30' || selectedAssignee.cica_positioncode === '10' || selectedAssignee.cica_positioncode === '14' || selectedAssignee.cica_positioncode === '13' || selectedAssignee.cica_positioncode === '60'
      || selectedAssignee.cica_positioncode === '76' || selectedAssignee.cica_positioncode === '16' || selectedAssignee.cica_positioncode === '31' || selectedAssignee.cica_positioncode === '75' || selectedAssignee.cica_positioncode === '33' || selectedAssignee.cica_positioncode === '70') {
      this.performAssignmentTask(selectedAssignee, personToSearch, tabSpecificRecords);
    }
  }
  showErrorMessage = (allowedLimit, currentCount) => {
    let errorMessage = 'An error occurred while assigning leads, Please try later';
    if (allowedLimit - currentCount === 0) {
      errorMessage = 'Leads not assigned, user has already been assigned the maximum number of leads';
    } else {
      errorMessage = `User can only be assigned ${allowedLimit - currentCount} more leads at this time`;
    }
    // show an alert.
    this.setState({
      active: true,
      errorMessage
    });
  }

  handleChange = (checkAssign) => {
    this.setState({
      checkAssign,
      valueSelected: []
    });
  };

  updateFilter = (key, value) => {
    this.setState({ valueSelected: [] });
    const request = new Promise((resolve) => {
      /* labelSelected = value ? value.map(item => item.label) : []; */

      this.setState({
        valueSelected: value
      });
      resolve(value);
    });
    return request;
  };

  radioButtonLabel = () => {
    if (this.props.ownerId) {
      // const tmRecord = _.find(this.props.agentList, ['systemuserid', this.props.ownerId]);
      // if (tmRecord && tmRecord.cica_positioncode === '10') {
      return 'Unassign';
      // }
    }
    return 'DM/SC';
  };

  checkIndex = () => {
    const { strings } = this.props;
    if (this.props.activeIndex === 1) {
      this.setState({ reConfirm: true, okMsg: strings.ok, cancelMsg: strings.cancel });
    } else if (this.props.activeIndex === 0) {
      this.confirm();
    }
  };

  checkForButtonDisable = () => {
    const tabSpecificRecords = (this.props.activeIndex) ?
      this.props.selectedRecords.filter(obj => obj.status === 'Assigned') :
      this.props.selectedRecords.filter(obj => obj.status === 'Unassigned');
    if (this.props.activeIndex === 1 && this.radioButtonLabel() === 'Unassign') {
      return !(tabSpecificRecords && tabSpecificRecords.length);
    }

    return !(this.state.valueSelected &&
              this.state.valueSelected.length &&
              tabSpecificRecords &&
              tabSpecificRecords.length);
  }

  render() {
    const { strings } = this.props;
    return (
      <div className={styles.flexFooter}>
        <div className={styles.emptyFooterContainer} />
        <div className={styles.assignContainer}>
          <div className={styles.dropdownContainer}>
            <div>
              {this.props.activeIndex === 1 &&
              <RadioGroup
                name="comic" value={this.state.checkAssign} onChange={this.handleChange}
                theme={styles}
              >
                <RadioButton
                  label={strings.unassign}
                  value="Unassign"
                  theme={styles}
                />
                <RadioButton
                  label={strings.reassign}
                  value="Re-Assign"
                  theme={styles}
                />
              </RadioGroup>}
            </div>
            {this.props.activeIndex === 0 &&
            <div className={styles.assignLabel}>
              {strings.assignto}
            </div>}
            <div className={styles.selectAssignee}>
              <VirtualizedSelect
                className={styles.inputDiv}
                labelKey="label"
                placeholder={strings.selectperson}
                hintText={strings.person}
                isFooter="yes"
                options={util.filterFooterOptionsData(null, this.getAgentList(), null)}
                valueKey="value"
                updateFilter={this.updateFilter}
                filterValues={this.state.valueSelected}
                currentLanguage={this.props.currentLanguage}
                singleSelect
                disabled={this.props.activeIndex === 1 && this.state.checkAssign === 'Unassign'}
                placeholderStyle={(this.props.activeIndex === 1 && this.state.checkAssign === 'Unassign') ? true : false} // eslint-disable-line
              />
            </div>
          </div>
          <Button
            raised
            className={styles.buttonStyle}
            theme={styles}
            onClick={this.checkIndex}
            disabled={this.checkForButtonDisable()}
          >
            {(this.props.activeIndex === 0) ? strings.confirmassign : strings.confirmassign}
          </Button>
        </div>
        <Dialog
          actions={[
            { label: strings.ok, onClick: this.handleToggle }
          ]}
          active={this.state.active}
          onEscKeyDown={this.handleToggle}
          onOverlayClick={this.handleToggle}
          title={'Alert'}
          className={styles.alertDialog}
          theme={styles}
          type={'normal'}
        >
          <p>{this.state.errorMessage}</p>
        </Dialog>
        <Modal
          isOpen={this.state.reConfirm}
          className="modalClass"
          overlayClassName="overlayClass"
        >
          <div className={styles.popupcontainer}>
            <div className={styles.popupDiv}>
              <div className={styles.popup}>
                <div className={styles.popupBodyDiv}>
                  <span className={styles.contentBody}>
                    {strings.reassignedLeads}
                  </span>
                </div>
                <div className={styles.popupFooterDiv}>
                  <div className={styles.okBtnDiv}>
                    <button
                      onClick={this.okBtnTap}
                      className={styles.okBtn}
                    >{this.state.okMsg}</button>
                    <button
                      onClick={this.cancelTap}
                      className={styles.okBtn}
                    >{this.state.cancelMsg}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isProgressBarRendered: state.app.progressBar.assign.show,
  dispositionOptionSet: state.assign.optionSet.disposition,
  username: state.topBar.username,
  isMarketOpen: state.assign && state.assign.isMarketOpen,
  primaryMarketId: state.assign && state.assign.ownerGuid,
  ownerGuid: state.assign && state.assign.ownerGuid,
  secondMarketValues: state.assign && state.assign.secondMarketValues,
  originalOwnerGuid: state.assign && state.assign.originalOwnerGuid
});

export default connect(mapStateToProps, filterActions)(Footer);



// WEBPACK FOOTER //
// ./src/containers/Footer/Footer.js